import DealsAddEdit from './DealsAddEdit'
export default DealsAddEdit
